import requireLoggedInSaga from './helpers/requireLoggedIn'; // polyfill webpack require.ensure

if (typeof require.ensure !== 'function') require.ensure = function (deps, cbFn) {
  return cbFn(require);
};
export default (function (store) {
  return {
    path: 'welcome/refer',
    onEnter: function onEnter(nextState, replaceState, cb) {
      return store.runSagaOnce(requireLoggedInSaga, nextState, replaceState).done.then(cb, cb);
    },
    getIndexRoute: function getIndexRoute(location, callback) {
      require.ensure([], function (require) {
        callback(null, {
          component: require('containers/CmsPage/CmsPage').CmsPage
        });
      }, 'try');
    }
  };
});